export const defineToastAutoDestroyTime = (
    hasError: boolean,
    success: boolean
) => {
    if (hasError) return 5000;
    if (success) return 3000;

    return undefined;
};

export const defineToastType = (hasError: boolean, success: boolean) => {
    if (hasError) return "error";
    if (success) return "success";

    return "loading";
};
